import { useMemo } from "react";
import type { useStateOfSalesV2Forecast } from "../state-of-sales-v2/useForecastData";
import { buildForecastDiagnosisStory } from "./forecastDiagnosisContract";

type ForecastModel = ReturnType<typeof useStateOfSalesV2Forecast>;

export function useForecastDiagnosisStory(model: ForecastModel) {
  return useMemo(() => {
    if (!model.forecast) return null;
    const preparedDealsById = new Map(
      [
        ...model.filteredPreparedDeals,
        ...model.filteredPreparedMovementOpenDeals,
        ...model.filteredEvaluatedForecastOpenDeals,
      ].map(deal => [String(deal.id), deal]),
    );

    return buildForecastDiagnosisStory({
      accumulated: model.accumulated,
      chartData: model.chartData,
      companyCurrency: model.companyCurrency,
      expectedCloseV2CompanyForecast: model.expectedCloseV2CompanyForecast,
      filteredPreparedDeals: Array.from(preparedDealsById.values()),
      forecast: model.forecast,
      period: model.period,
    });
  }, [
    model.accumulated,
    model.chartData,
    model.companyCurrency,
    model.expectedCloseV2CompanyForecast,
    model.filteredPreparedDeals,
    model.filteredPreparedMovementOpenDeals,
    model.filteredEvaluatedForecastOpenDeals,
    model.forecast,
    model.period,
  ]);
}
